/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

import AppHandler from '~/core/app-handler'
import Bugsnag from '~/core/bugsnag'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import EventBus from '~/core/event-bus'
import { focus, reportError, sleep } from '~/core/global-functions'
import Quicklink from '~/core/quicklink'
import Query from '~/core/query'
import { domReady } from '~/core/runners'
import TagHandler from '~/core/tag-handler'
import invertHeaderColor from '~/components/invert-header-color'

/**
 * Global Canvas variables.
 */
window.cnvs = window.cnvs || {}
window.cnvs.started = false

/**
 * Global Canvas functions.
 */
window.cnvs.EventBus = EventBus()
window.cnvs.Helpers = Commands().cli()
window.cnvs.Query = (query, useCache) => Query(query, useCache)

window.cnvs.Focus = focus
window.cnvs.ReportError = reportError
window.cnvs.Sleep = sleep

/**
 * DOM ready.
 */
domReady(() => {
  Bugsnag().init()
  Commands().init()

  AppHandler().beforeVueInit()

  TagHandler().init()
  Canvas().init()
  AppHandler().afterVueInit()


/*for task 36*/

// function applyTasteNotesAccessibility() {
//   const items = document.querySelectorAll(".taste-notes__item");
 
//   items.forEach((item) => {
//     // Skip if already processed
//     if (item.getAttribute("aria-label")) return;
 
//     const title = item.querySelector(".text-other-label-s")?.innerText.trim();
//     const leftLabel = item.querySelector(
//       ".taste-notes__details > p:not(.taste-notes__levels--label)"
//     )?.innerText.trim();
//     const rightLabel = item.querySelector(".taste-notes__levels--label")?.innerText.trim();
//     const dots = item.querySelectorAll(".taste-notes__levels--item").length;
 
//     if (!title || !dots) return;
 
//     let ariaText = `${title}: ${dots} out of 5`;
//     if (leftLabel && rightLabel) ariaText += ` — ${leftLabel} to ${rightLabel}`;
 
//     item.setAttribute("role", "img");
//     item.setAttribute("aria-label", ariaText);
 
//     const dotsContainer = item.querySelector(".taste-notes__levels");
//     if (dotsContainer) dotsContainer.setAttribute("aria-hidden", "true");
//   });
// }
 
// // MutationObserver → runs every time Vue updates DOM
// const observer = new MutationObserver(() => {
//   applyTasteNotesAccessibility();
// });
 
// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
// });
 
// // First call (in case taste notes already rendered)
// applyTasteNotesAccessibility();
 
function applyTasteNotesAccessibility() {
  const items = document.querySelectorAll(".taste-notes__item");

  items.forEach((item) => {
    // Prevent re-processing
    if (item.getAttribute("aria-label")) return;

    const leftLabel = item
      .querySelector(".taste-notes__details > p:not(.taste-notes__levels--label)")
      ?.innerText.trim();

    const rightLabel = item
      .querySelector(".taste-notes__levels--label")
      ?.innerText.trim();

    const dots = item.querySelectorAll(".taste-notes__levels--item").length;
    const maxDots = 5;

    if (!dots || !leftLabel || !rightLabel) return;

    // 🔊 Screen reader text exactly matching visual meaning
    const ariaText = `${leftLabel} to ${rightLabel}, ${dots} of ${maxDots}`;

    item.setAttribute("role", "img");
    item.setAttribute("aria-label", ariaText);

    const dotsContainer = item.querySelector(".taste-notes__levels");
    if (dotsContainer) {
      dotsContainer.setAttribute("aria-hidden", "true");
    }
  });
}

// Handle Vue re-renders
const observer = new MutationObserver(() => {
  applyTasteNotesAccessibility();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Initial run
applyTasteNotesAccessibility();
















/**end **/

  Quicklink().init()
  invertHeaderColor().init()
})
